import { i18n } from '@/plugins/i18n';

/**
 * Convert prep time in minutes to a formatted label
 * @param {number} minutes - Preparation time in minutes
 * @returns {string} - Formatted preparation time
 */
export default function prepTimeToLabel(minutes) {
    if (minutes < 120) {
        return `${minutes} - ${minutes + 10} ${i18n.t('timeUnits.minutes')}`;
    } else if (minutes < 1440) {
        return `${Math.floor(minutes / 60)} ${i18n.t('timeUnits.hours')}`;
    }

    return `${Math.floor(minutes / 60 / 24)} ${i18n.t('timeUnits.days')}`;
}
